import { postCrossTabSaveSignal, subscribeCrossTabSaveSignal } from './crossTabSaveSignal';

/** 프로그램 진도표 저장 후 연간진도표 등이 같은 학년·학기 데이터를 다시 불러오게 할 때 사용 */

export const PROGRAM_PROGRESS_SAVED_EVENT = 'cp:program-progress-saved';

/**
 * full: 구조 변경·첨부 flush 등 — React Query invalidate + 페이지 전량 재조회
 * cache: 칸(글자) 편집만 — upsert 응답으로 캐시 반영, 전량 refetch 생략
 */
export type ProgramProgressUiRefreshMode = 'full' | 'cache';

export type ProgramProgressSavedDetail = {
  workspaceId: string;
  academicYear: number;
  termNumber: 1 | 2;
  gradeId: string;
  /** 생략 시 full(기존 동작) */
  uiRefreshMode?: ProgramProgressUiRefreshMode;
  /** 다른 탭에서 온 신호(다시 다른 탭으로 보내지 않음) */
  remote?: boolean;
};

export function emitProgramProgressSaved(detail: ProgramProgressSavedDetail): void {
  if (typeof window === 'undefined') return;
  if (!detail.gradeId) return;
  window.dispatchEvent(
    new CustomEvent(PROGRAM_PROGRESS_SAVED_EVENT, {
      detail: {
        ...detail,
        uiRefreshMode: detail.uiRefreshMode ?? 'full',
      },
    })
  );
  if (!detail.remote) {
    postCrossTabSaveSignal('program-progress-saved', { ...detail, uiRefreshMode: 'full' });
  }
}

/** 다른 탭 저장 → 이 탭 화면은 전체 다시 읽기(full: 머리 정보 비교 후 바뀐 것만 받음) */
subscribeCrossTabSaveSignal('program-progress-saved', (raw) => {
  const d = raw as Partial<ProgramProgressSavedDetail>;
  const termNumber = d.termNumber === 1 || d.termNumber === 2 ? d.termNumber : null;
  if (!d.workspaceId || !d.gradeId || typeof d.academicYear !== 'number' || !termNumber) return;
  emitProgramProgressSaved({
    workspaceId: d.workspaceId,
    academicYear: d.academicYear,
    termNumber,
    gradeId: d.gradeId,
    uiRefreshMode: 'full',
    remote: true,
  });
});
